const getUrlObject = (urls, instancename, urlname, action) => {
  /**
   * Ищет URL объект в структуре данных
   * @param {Object} urls - объект со всеми URL
   * @param {string} instancename - имя инстанса
   * @param {string} urlname - имя эндпоинта
   * @param {string} action - HTTP метод
   * @returns {Object|null} найденный URL объект или null
   */
  return urls[instancename]
    .find(x => x.name === urlname).methods
    .find(x => x.action === action)
}

const state = {
  urls: {}
}

const mutations = {
  appendUrls (state, urls) {
    /**
     * Добавляет новые URL эндпоинты в хранилище
     * @param {Object} state - состояние хранилища
     * @param {Object} urls - объект с новыми URL
     */
    const new_keys = Object.keys(urls)
    const existed_keys = Object.keys(state.urls)
    for (const i in new_keys) {
      if (!(new_keys[i] in existed_keys)) {
        state.urls[new_keys[i]] = urls[new_keys[i]]
      }
    }
  },
  clearUrls (state) {
    /**
     * Очищает все URL из хранилища
     * @param {Object} state - состояние хранилища
     */
    state.urls = {}
  }
}

const getters = {
  getInstance: (state) => (instance) => {
    /**
     * Получает весь инстанс с его эндпоинтами
     * @param {Object} state - состояние хранилища
     * @returns {Function} функция, принимающая имя инстанса
     */
    try {
      const urls = state.urls[instance]
      urls.getUrl = function (name) {
        return this[name]
      }
      return urls
    } catch (e) {
      return {}
    }
  },

  getPattern: (state) => (instancename, urlname, action) => {
    /**
     * Возвращает паттерн URL для конкретного эндпоинта и инстанса
     * @param {Object} state - состояние хранилища
     * @returns {Function} функция, принимающая параметры для поиска
     */
    try {
      return getUrlObject(state.urls, instancename, urlname, action).pattern
    } catch (e) {
      return ''
    }
  },

  getAllowed: (state) => (instancename, urlname, action) => {
    /**
     * Возвращает список разрешений для эндпоинта
     * @param {Object} state - состояние хранилища
     * @returns {Function} функция, принимающая параметры для поиска
     */
    try {
      return getUrlObject(state.urls, instancename, urlname, action).allowed
    } catch (e) {
      return ''
    }
  },

  getUrl: (state) => (instancename, urlname, action) => {
    /**
     * Возвращает полный URL объект
     * @param {Object} state - состояние хранилища
     * @returns {Function} функция, принимающая параметры для поиска
     */
    try {
      return getUrlObject(state.urls, instancename, urlname, action)
    } catch (e) {
      return null
    }
  },

  checkAlreadyLoaded: (state) => (instancename) => {
    /**
     * Проверяет, загружен ли инстанс
     * @param {Object} state - состояние хранилища
     * @returns {Function} функция, принимающая имя инстанса
     */
    if (instancename in state.urls) { return true }
    return false
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
